
export class BasketWrapper {

   /**
    * @returns true if payment occured
    */
  hasPayment() {
    throw new Error('You must implement \'hasPayment\' for this retailer');
  }


   /**
    * @returns payment total when a payment occured
    */
  paymentTotal(){
    throw new Error('You must implement \'paymentTotal\' for this retailer');
  }

   /**
    *  Here we listen to Retailer basket change and then call the given
    *  retailerBasketChangeCallBack
    *  @param {Function} retailerBasketChangeCallBack  implemented in basket handler
    */
   // eslint-disable-next-line no-unused-vars
   listenToRetailerBasket(retailerBasketChangeCallBack){
     throw new Error('You must implement \'lisentToRetailerBasket\' for this retailer');
   }

   /**
    * @return a list of articles in retailer's basket in RETAILER format
    */
   getBasketProducts(){
     throw new Error('You must implement \'getBasketProducts\' for this retailer');
   }

   /**
    * This call retailer function for adding programaticaly product to cart
    * @param {Object} retailerProducts format use by retailer to add product in his cart
    */
   // eslint-disable-next-line no-unused-vars
   pushProductsToBasket(retailerProducts){
     throw new Error('You must implement \'pushProductsToBasket\' for this retailer');
   }

  /**
   * transform object to needed format to push on retailer basket
   * @param {Object} injectEntry 
   * @returns product to  retailer format
   */
  // eslint-disable-next-line no-unused-vars
  mapEntryToProduct(injectEntry){
    throw new Error('You must implement \'mapEntryToProduct\' for this retailer');
  }

  /**
   * transforms product (and potentially additional parameters such as quantity) 
   * @param {Object} retailerProduct  product of retailer format
   * @returns  miam format
   */
  // eslint-disable-next-line no-unused-vars
  mapProductToEntry(retailerProduct){
    throw new Error('You must implement \'mapProductToEntry\' for this retailer');
  }
   
}
